export default __webpack_public_path__ + "static/media/340.222f806c.png";